// Types
import { SUBSCRIPTIONS_ACTIONS } from "./types";
import { UPDATE_MODEL } from "@/store/mutations-types";
// Services
import sseService from "@/services/sse";
// Utils
import { setTimeoutAsync } from "@/utils/planningAsync";
// Constants
import { TYPE_EVENT_SSE } from "@/constants/typesEventsSse";

export default {
  state: {
    model: {
      triggerd: {
        meetingInvitations: false,
      },
      source: {
        meetingInvitations: null,
      },
    },
  },
  actions: {
    [SUBSCRIPTIONS_ACTIONS.UNSUBSCRIBE]({ state, commit }, subscribeName) {
      if (!(subscribeName in state.model.source)) {
        throw new Error(`The specified subscription name ${subscribeName} is missing!`);
      }

      // Close sse connection
      state.model.source[subscribeName]?.close();

      commit(UPDATE_MODEL, {
        name: SUBSCRIPTIONS_ACTIONS.MODULE_SUBSCRIPTIONS,
        model: {
          source: {
            [subscribeName]: null,
          },
        },
      });
    },
    [SUBSCRIPTIONS_ACTIONS.UNSUBSCRIBE_ALL]({ state, dispatch }) {
      const allSubscriptions = Object.keys(state.model.source);
      allSubscriptions.forEach((subscribeName) =>
        dispatch(SUBSCRIPTIONS_ACTIONS.UNSUBSCRIBE, subscribeName)
      );
    },
    [SUBSCRIPTIONS_ACTIONS.SUBSCRIBE_MEETING_INVITATIONS]({ state, commit, dispatch }, judgeId) {
      if (state.model.source.meetingInvitations) {
        return;
      }

      const sseSubscribe = sseService.subscribeMeetingInvitations(judgeId);

      sseSubscribe.on(TYPE_EVENT_SSE.DATA, () => {
        commit(UPDATE_MODEL, {
          name: SUBSCRIPTIONS_ACTIONS.MODULE_SUBSCRIPTIONS,
          model: {
            triggerd: {
              meetingInvitations: true,
            },
          },
        });

        dispatch(SUBSCRIPTIONS_ACTIONS.AUTO_RESET_TRIGGER_STATUS, "meetingInvitations");
      });

      // eslint-disable-next-line promise/prefer-await-to-then
      sseSubscribe.catch(() => {
        dispatch(SUBSCRIPTIONS_ACTIONS.UNSUBSCRIBE, "meetingInvitations");
        dispatch(SUBSCRIPTIONS_ACTIONS.SUBSCRIBE_MEETING_INVITATIONS, judgeId);
      });

      commit(UPDATE_MODEL, {
        name: SUBSCRIPTIONS_ACTIONS.MODULE_SUBSCRIPTIONS,
        model: {
          source: {
            meetingInvitations: sseSubscribe,
          },
        },
      });
    },
    async [SUBSCRIPTIONS_ACTIONS.AUTO_RESET_TRIGGER_STATUS]({ state, commit }, subscribeName) {
      if (!(subscribeName in state.model.triggerd)) {
        throw new Error(`The specified subscription name ${subscribeName} is missing!`);
      }

      await setTimeoutAsync(3000);
      commit(UPDATE_MODEL, {
        name: SUBSCRIPTIONS_ACTIONS.MODULE_SUBSCRIPTIONS,
        model: {
          triggerd: {
            [subscribeName]: false,
          },
        },
      });
    },
  },
  getters: {
    [SUBSCRIPTIONS_ACTIONS.GET_STATUS_TRIGGER]: (state) => (subscribeName) => {
      if (!(subscribeName in state.model.triggerd)) {
        throw new Error(`The specified subscription name ${subscribeName} is missing!`);
      }

      return state.model.triggerd[subscribeName];
    },
  },
};
